import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CourseCatalogPostingStream } from 'app/library/course-catalog-landing-page/models/course-catalog-posting-stream.model';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IMaxBrainEnvironment } from 'app/projects/shared/src/lib/interfaces/environment.interface';

@Component({
    selector: 'app-select-course-offering-posting',
    templateUrl: './select-course-offering-posting.component.html',
    styleUrls: ['./select-course-offering-posting.component.scss'],
})
export class SelectCourseOfferingPostingCardComponent {
    @Input()
    offerringGroupOfferings: CourseCatalogPostingStream[];

    @Input()
    isSelectable: boolean = false;

    @Input()
    isSelectDisabled = false;

    @Output()
    onSelectCourse = new EventEmitter<CourseCatalogPostingStream>();

    @Output()
    onDeselectCourse = new EventEmitter<CourseCatalogPostingStream>();

    unsplashViewsBaseUrl: string;

    constructor(@Inject(MAXBRAIN_ENVIRONMENT) private _environment: IMaxBrainEnvironment, private _router: Router) {
        this.unsplashViewsBaseUrl = this._environment.unsplashViewsBaseUrl;
    }

    navigateToCourseOfferingExecutionList(offeringId: string) {
        this._router.navigate([`admin/offering-details/${offeringId}/overview`]);
    }

    onSelectCourseOffering(courseOffering: CourseCatalogPostingStream): void {
        if (this.isSelectDisabled) {
            return;
        }

        courseOffering.isSelected = true;
        this.onSelectCourse.emit(courseOffering);
    }

    onDeselectCourseOffering(courseOffering: CourseCatalogPostingStream): void {
        courseOffering.isSelected = false;
        this.onDeselectCourse.emit(courseOffering);
    }
}
